import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

moment.locale('sv');

class RelativeTime extends Component {
    static propTypes = {
        date: PropTypes.number.isRequired,
    }

    shouldComponentUpdate(nextProps) {
        return this.props.date !== nextProps.date;
    }

    renderTime() {
        const time = moment(this.props.date);

        if (time.isSame(moment().startOf('day'), 'd')) {
            return time.format('HH:mm');
        } else if (time.isSame(moment().startOf('year'), 'y')) {
            return time.format('DD.MM - HH:mm');
        }

        return time.format('DD.MM.YYYY - hh:mm');
    }

    render() {
        return (
            <time dateTime={moment(this.props.date).format('YYYY-MM-DDThh:mm')}>
                {this.renderTime()}
            </time>
        );
    }
}

export default RelativeTime;



/** WEBPACK FOOTER **
 ** /src/shared/components/RelativeTime.js
 **/